import { trackEvent, eventNameConstants } from 'dibs-tracking';

const { EVENT_PROMO_INTERACTION } = eventNameConstants;

export const trackTradeBenefitsEvent = ({
    stepInteractionName,
    trigger,
    stepType,
}: {
    stepInteractionName: string;
    trigger: string;
    stepType?: string;
}): void => {
    trackEvent({
        eventName: EVENT_PROMO_INTERACTION,
        interaction_type: 'trade benefits page',
        step_interaction_name: stepInteractionName,
        trigger,
        ...(stepType ? { step_type: stepType } : {}),
    });
};
